import { supabase } from '../supabaseClient';
import DisplayToggles from './DisplayToggles';

export default function Login() {
  const handleGoogleLogin = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin,
        queryParams: { hd: 'inpulsedigital.com' }, // hint: show workspace accounts first
      },
    });
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: 'var(--bg)',
    }}>
      <DisplayToggles floating />
      <div style={{
        background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 16,
        padding: '48px 56px', textAlign: 'center', maxWidth: 400, width: '100%',
        boxShadow: '0 4px 24px rgba(0,0,0,.15)',
      }}>
        {/* Logo mark */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10, marginBottom:32 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 8,
            background: 'linear-gradient(135deg, #16a34a, #2563eb)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <span style={{ color: '#fff', fontWeight: 800, fontSize: 16 }}>IP</span>
          </div>
          <span style={{ fontWeight: 700, fontSize: 18, letterSpacing: '-0.3px' }}>INPULSE Core Operations</span>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8, letterSpacing: '-0.4px' }}>
          Welcome back
        </h1>
        <p style={{ color: 'var(--text2)', fontSize: 14, marginBottom: 32 }}>
          Sign in with your INPULSE Google Workspace account to access the team analytics dashboard.
        </p>

        <button
          onClick={handleGoogleLogin}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: 12, width: '100%', padding: '12px 20px',
            background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 10,
            cursor: 'pointer', fontSize: 15, fontWeight: 600,
            boxShadow: '0 1px 3px rgba(0,0,0,.08)',
            transition: 'box-shadow .15s, border-color .15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor='var(--green)'; e.currentTarget.style.boxShadow='0 2px 8px rgba(22,163,74,.12)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.boxShadow='0 1px 3px rgba(0,0,0,.08)'; }}
        >
          <GoogleIcon />
          Continue with Google
        </button>

        <p style={{ color: 'var(--text3)', fontSize: 12, marginTop: 24 }}>
          Access is restricted to approved INPULSE team members.
        </p>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
      <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
      <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
      <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
    </svg>
  );
}
